/* Progressive enhancement: complete results remain server-rendered without JS. */
(() => {
  const enhanceTabs = (root, controls, buttonKey, panelKey, selected) => {
    if (!controls || controls.dataset.enhanced) return;
    const tabs = [...controls.querySelectorAll(`[${buttonKey}]`)];
    const panels = [...root.querySelectorAll(`[${panelKey}]`)];
    if (!tabs.length) return;
    controls.dataset.enhanced = 'true';
    controls.setAttribute('role', 'tablist');
    const activate = (tab, focus = false) => {
      const key = tab.getAttribute(buttonKey);
      tabs.forEach(item => {
        const active = item === tab;
        item.setAttribute('aria-selected', String(active));
        item.tabIndex = active ? 0 : -1;
      });
      panels.forEach(panel => { panel.hidden = panel.getAttribute(panelKey) !== key; });
      if (focus) tab.focus();
    };
    tabs.forEach((tab, index) => {
      const panel = panels.find(item => item.getAttribute(panelKey) === tab.getAttribute(buttonKey));
      if (!panel) return;
      tab.setAttribute('role', 'tab');
      tab.id = `${panel.id}-tab`;
      tab.setAttribute('aria-controls', panel.id);
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', tab.id);
      panel.tabIndex = 0;
      tab.addEventListener('click', event => { event.preventDefault(); activate(tab); });
      tab.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next !== undefined) { event.preventDefault(); activate(tabs[next], true); }
        if (event.key === ' ') { event.preventDefault(); activate(tab); }
      });
    });
    activate(tabs.find(tab => tab.getAttribute(buttonKey) === selected) || tabs[0]);
  };
  const init = scope => {
    scope.querySelectorAll('[data-results-hub]').forEach(root => {
      enhanceTabs(root, root.querySelector('[data-results-tabs]'), 'data-results-tab', 'data-results-panel', 'supercross');
      const select = root.querySelector('[data-results-season]');
      if (select && !select.dataset.enhanced) {
        select.dataset.enhanced = 'true';
        select.addEventListener('change', () => {
          const url = new URL(select.value, location.origin);
          if (url.origin === location.origin && url.pathname.startsWith('/pages/')) location.assign(url.href);
        });
      }
    });
    scope.querySelectorAll('[data-results-event-page]').forEach(root => {
      enhanceTabs(root, root.querySelector('[data-results-classes]'), 'data-results-class-tab', 'data-results-class');
      root.querySelectorAll('[data-results-class]').forEach(group => {
        enhanceTabs(group, group.querySelector('[data-results-sessions]'), 'data-results-session-tab', 'data-results-session');
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', () => init(document));
})();
